// Polling Keep-Alive Utility
// Ensures polling continues even when browser tab is in background
// Uses Web Worker to bypass browser throttling of setInterval

const workerCode = `
  let timers = {};
  self.onmessage = function(e) {
    const { action, id, interval } = e.data;
    if (action === 'start') {
      if (timers[id]) clearInterval(timers[id]);
      timers[id] = setInterval(() => self.postMessage({ id }), interval);
    } else if (action === 'stop') {
      if (timers[id]) { clearInterval(timers[id]); delete timers[id]; }
    } else if (action === 'stopAll') {
      Object.keys(timers).forEach(k => clearInterval(timers[k]));
      timers = {};
    }
  };
`;

let worker = null;
const callbacks = {};

function getWorker() {
  if (!worker) {
    try {
      const blob = new Blob([workerCode], { type: 'application/javascript' });
      worker = new Worker(URL.createObjectURL(blob));
      worker.onmessage = (e) => {
        const { id } = e.data;
        if (callbacks[id]) callbacks[id]();
      };
    } catch (err) {
      // Web Worker not supported - fallback to setInterval
      console.warn('Web Worker not available, using setInterval fallback');
      return null;
    }
  }
  return worker;
}

// Start a background-safe polling timer
// Returns a cleanup function
export function startPolling(id, callback, intervalMs = 2000) {
  const w = getWorker();
  
  if (w) {
    callbacks[id] = callback;
    w.postMessage({ action: 'start', id, interval: intervalMs });
    return () => {
      w.postMessage({ action: 'stop', id });
      delete callbacks[id];
    };
  } else {
    // Fallback: regular setInterval
    const timer = setInterval(callback, intervalMs);
    return () => clearInterval(timer);
  }
}

// Stop all polling
export function stopAllPolling() {
  const w = getWorker();
  if (w) {
    w.postMessage({ action: 'stopAll' });
    Object.keys(callbacks).forEach(k => delete callbacks[k]);
  }
}

// Visibility-aware fetch: immediately fetch when tab becomes visible
// Also restarts polling to ensure fresh interval
export function onVisibilityFetch(fetchFn) {
  const handler = () => {
    if (document.visibilityState === 'visible') {
      fetchFn();
    }
  };
  
  document.addEventListener('visibilitychange', handler);
  window.addEventListener('focus', handler);
  
  return () => {
    document.removeEventListener('visibilitychange', handler);
    window.removeEventListener('focus', handler);
  };
}
